export interface SignUpUser {
  firstName: string;
  lastName: string;
  username: string;
  phoneNumber: string;
  password: string;
  zipCode: string;
}
